import { HeroEventProps } from '@sbercloud/uikit-product-site-hero';

export const getHeroBackgroundColor = (): HeroEventProps['backgroundColor'] => {
  return 'neutral-background'; // TODO: add both colors to CMS picker and fix this temporary solution
};
